import { AfterViewInit, Component, ElementRef, OnInit ,OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import {StoreService} from '../store.service';

@Component({
  selector: 'app-exercise-work',
  templateUrl: './exercise-work.component.html',
  styleUrls: ['./exercise-work.component.css', '../../assets/css/font-size.css'],
})

export class ExerciseWorkComponent implements OnInit, AfterViewInit , OnDestroy {

  lpmapcId: number; //learningPathMetasApplicationPracticeConstituteId
  learningPathMetaId: number; //learningPathMetaId
  openFlag: number = 1; //是否隐私提交
  exerciseGroup: any; //作业簿
  exerciseType: number; //练习类型
  isOpenClass: number = 0; //是否公开课
  allQuestionsNumber: number = 1;//题目数量
  currentNumber: number = 1;//当前完成题目数量
  page: string; //页面
  theme: string = 'sight'; //主题
  canSave: boolean = false; //是否可以保存
  isSave: boolean = false;
  clickAble:boolean = true;//防止多次点击
  bodyHeight: string; //答题模块的高度
  postData: any;//提交的答案
  isShowTip: boolean = false;//是都显示提示框
  isCollapse: boolean = true; //是否收拢
  isShowToast: boolean = false; //是否显示toast
  toastType: number; //toast类型
  tipType: string = "";//提示框类型
  errTxt: string; //上传错误提示
  buttonTxt: string; //按钮文案
  isLastDay: boolean; //是否作业最后一天
  pdfList: any;  //pdf列表
  uploadId: string = ''; //查询上传文件条件
  uploadList: any; //上传文件集合
  oldUploadList: any; //之前的上传文件集合
  isOnlyCamp: any; //只有训练营
  uploadDisabled: boolean = false; //是否允许上传
  isFirstDay: any; //day1
  isShowPreview: boolean = false; //是否显示预览
  previewSource: any; //预览源
  isShowLoading: boolean = false; //是否显示loading
  isPopupEnter: boolean = false;
  isWechat: boolean = false; //是否微信
  isShowPopup: boolean = false;
  assetsRoute: string = '../../assets';
  saveError: boolean = false;
  isShowFinishTip: boolean = false;//是否完成题目
  isSlideFinal: boolean = false;//题目是否做完
  isShowBackDesc: boolean = false;//是否展示背景描述
  isNextQuestion: boolean = false;//是否解锁下一题
  checkBoxSelector : any;//多选题选项
  downloadUrl : any;
  headTitle : string ="";
  blankSave : boolean = true;//空保存  false : 不是空保存 true:是空保存
  projectId : number;
  courseLearningPathMetaId : number;
  isNeedCorrect: boolean = true; //试卷是否需要批改 默认需要
  tempWorkStatus: number = 0;//临时作业状态，这里是用来判断当前作业状态如果大于等于20就不再次提交
  checkElse : boolean = false;//实战作业是否选择了其他这个选项
  onceValue : Number = 0;
  terminalType: Number = 0;
  showUrlText:string = "";
  campId:number=0;
  isClick : number = 0;//是否第一次点击过lastday的pdf
  constructor(private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private apiService: ApiService,
    private commonService: CommonService,
    private storeService:StoreService) {
  }

  ngOnInit() {
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.campId = Number(localStorage.getItem('campId'));
    this.isWechat = this.commonService.isWeiXin();

    $('#userIdContainer').val(localStorage.getItem('userId'));
    this.route.params.subscribe(params => {
      this.lpmapcId = params['lpmapcId'];
      this.learningPathMetaId = params['learningPathMetaId'];
    });

    this.route.queryParams.subscribe(params => {
      this.isLastDay = !!params['isLastDay'];
      this.isOnlyCamp = !!params['onlyCamp'];
      this.isFirstDay = params['firstDay'];
      this.projectId = params['projectId'];
      this.courseLearningPathMetaId = params['courseLearningPathMetaId'];
    });

    if(this.isLastDay && JSON.parse(localStorage.getItem("exerciseGroup"))){
      this.exerciseGroup = JSON.parse(localStorage.getItem("exerciseGroup"));
      this.terminalType = this.exerciseGroup.terminalType == 1? 1:2;
      this.exerciseType = this.exerciseGroup['type'];
      this.uploadList = localStorage.getItem("uploadList") && JSON.parse(localStorage.getItem("uploadList")) ? JSON.parse(localStorage.getItem("uploadList")) : [];
      this.pdfList = JSON.parse(localStorage.getItem("pdfList"));
      if(localStorage.getItem("uploadId")){
        this.uploadId = localStorage.getItem("uploadId");
      }
      this.page = this.exerciseGroup.status == 0 || this.exerciseGroup.status == 10? 'list' : 'finish';
      this.currentNumber = 4;
      this.allQuestionsNumber = this.exerciseGroup['questionGroup'].length;
      this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
      this.blankSave = this.postData.some(item=>item.selector && item.selector !=null)? false : true;
      this.buttonTxt = this.exerciseType === 3 && !this.isLastDay ? this.exerciseGroup.questionGroupMetaTitle : '一共' + this.allQuestionsNumber + '小题，立即作答';
      this.titleText();
      this.isNextQuestion = false;
      this.getOnceValue();
    }else{
      this.getExerciseDetailAPI(this.lpmapcId).then(result => {
        this.exerciseGroup = result;
        this.exerciseType = this.exerciseGroup['type'];
        this.isNeedCorrect = this.exerciseGroup.needCorrect === 1;
        this.page = result.status <20? 'list' : 'finish';
        this.allQuestionsNumber = this.exerciseGroup['questionGroup'].length;
        this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
        this.blankSave = this.postData.some(item=>item.selector && item.selector !=null)? false : true;
        this.buttonTxt = this.exerciseType === 3 && !this.isLastDay ? this.exerciseGroup.questionGroupMetaTitle : '一共' + this.allQuestionsNumber + '小题，立即作答';
        this.titleText();
      }).then(() => {
        if (this.isLastDay) {
          let index = this.commonService.getIndexByConditionIdInLists(this.exerciseGroup['questionGroup'], 'type', 5);
          this.uploadId = this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
          this.getExercisePdfAPI({
            'campMetaId': Number(localStorage.getItem('campId')),
            'optionsIds': this.exerciseGroup['questionGroup'][0]['answers']
          }).then(result => {
            this.pdfList = result;
            this.checkElse = result.length>0 ? false : true;
          });

          this.getUploadFileList({
            'constituteId': this.lpmapcId,
            'questionId': this.exerciseGroup['questionGroup'][index]['questionId'],
            'campFileUploadIds': this.uploadId
          }).then(result => {
            this.uploadList = result['newFileList'];
            this.oldUploadList = result['oldFileList'];
            this.uploadDisabled = this.uploadList.length === 10;
            this.terminalType = this.isLastDay && this.exerciseGroup.terminalType == 1 && this.uploadList.length>0? 1:2;
          });
          this.getOnceValue();
        }
      });
    }

    localStorage.removeItem("moduleId");
  }

  ngAfterViewInit() {
    const self = this;
    this.commonService.initPage({
      'backgroundColor': 'rgba(40,51,130,1)'
    });
    $('body').css('height', 'auto');

    $('#wx-open-wrap').css('left', '-200%');
    window.addEventListener("popstate",function(){
      if(self.downloadUrl == document.referrer){
        self.isLastDay = true;
        self.page = "answer";
        self.currentNumber = self.exerciseGroup['questionGroup'].length;
      }
    })
    // let wxBtn = document.body.querySelector(".wx-open-tag") as HTMLElement;
    // wxBtn.style.display = "block";
  }

  ngOnDestroy(){
    localStorage.removeItem("exerciseGroup");
    localStorage.removeItem("uploadList");
    localStorage.removeItem("pdfList");
    localStorage.removeItem("uploadId");
    localStorage.removeItem("canSave");
  }

  //获取lastDay的OnceValue
  getOnceValue(){
    this.onceValue = this.exerciseGroup?this.commonService.getOnceValue(Number(this.exerciseGroup['questionGroup'][this.exerciseGroup['questionGroup'].length-1].questionId), 11) : 0;
    this.showUrlText =  window.location.hostname === 'm.transtalent.cn'? "电脑端填写表单更方便哦。快点击“复制网址”，在电脑浏览器进行作答吧！<br><br>链接：https://m.transtalent.cn/pc/applytask":"电脑端填写表单更方便哦。快点击“复制网址”，在电脑浏览器进行作答吧！<br><br>链接：https://m-uat.transtalent.cn/pc/applytask";
    this.commonService.getOnceIno(this.onceValue).then(result=>{
      this.isClick = result;
    })
  }

  //背景描述
  backgroundDesc() {
    this.isShowBackDesc = !this.isShowBackDesc;
  }

  titleText(){
    if(this.page === 'list'){
      if(this.isFirstDay || this.isLastDay){
        this.headTitle = this.exerciseGroup.status === 0? "实战作业" : '';
      }else{
        this.headTitle = this.exerciseGroup.status === 0? "今日作业" : '';
      }
    }else if(this.page === 'answer'){
      this.headTitle = this.currentNumber + "/" + this.allQuestionsNumber;
    }
  }

  formatPostData(group: any): any {
    let data = [];
    group.forEach(item => {
      if (item['type'] === 3 || item['type'] === 6 || item['type'] === 8) {
        data.push({
          'constituteId': this.lpmapcId,
          'questionId': item['questionId'],
          'tableData': item['tableData'],
          'type': item['type']
        })
      } else {
        data.push({
          'constituteId': this.lpmapcId,
          'questionId': item['questionId'],
          'selector': item['answers'],
          'type': item['type']
        })
      }
    });
    return data;
  }


  //获取练习册本体的高度
  setBodyHeight(event: number): void {
    this.bodyHeight = event + 'rem';
  }

  //获取收拢展开
  getIsCollapse(event: boolean): void {
    this.isCollapse = event;
  }

  /**
   * 进入答题页面
   * @param status:Number  进入答题页面状态（0：立即作答 1：编辑）
   */
  goAnswer(status: number): void {
    this.clickAble = true;
    this.currentNumber = 1;
    if(this.isLastDay){
      this.checkElse = this.exerciseGroup.questionGroup[0].answers ==  this.exerciseGroup['questionGroup'][0].options[this.exerciseGroup['questionGroup'][0].options.length -1].optionId? true : false;
    }
    let data = status === 0 ? { 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷立即作答', 'courseUnit': this.lpmapcId, 'type': 0 } : { 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷编辑', 'courseUnit': this.lpmapcId, 'type': 0 };
    this.commonService.learningPortEventLogByCandy(data).then(() => {
      this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': this.lpmapcId, 'type': 1 }).then();
    });
    this.getExerciseDetailAPI(this.lpmapcId).then(result => {
      this.exerciseGroup = result;
      this.terminalType = this.isLastDay && this.exerciseGroup.terminalType == 1 && this.uploadList.length>0? 1:2;
      this.allQuestionsNumber = this.exerciseGroup['questionGroup'].length;
      this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
      this.pageChangedInit('sight', 'answer', 'rgba(40,51,130,1)','linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
      this.titleText();
      if(status == 1) this.blankSave = false;
    });
    this.openNextQuestion();
    localStorage.setItem("uploadList",JSON.stringify(this.uploadList));
  }

  //是否解锁下一题
  openNextQuestion() {
    //判断是否可以解锁下一题
    if (this.postData[this.currentNumber - 1].type === 3 || this.postData[this.currentNumber - 1].type === 6 || this.postData[this.currentNumber - 1].type === 8) {
      //表格题
      let a = [];
      this.postData[this.currentNumber - 1]['tableData'].forEach(item => {
        item.forEach(item3 => {
          a.push(item3);
        });
      })
      a.some(item => item !== '') && a.length >1 ? this.isNextQuestion = true : this.isNextQuestion = false;
    } else if (this.postData[this.currentNumber - 1].type === 2 || this.postData[this.currentNumber - 1].type === 4) {
      //选择题
      this.postData[this.currentNumber - 1].selector ? this.isNextQuestion = true : this.isNextQuestion = false;
    } else if (this.postData[this.currentNumber - 1].type === 1) {
      //文本题
      this.postData[this.currentNumber - 1].selector ? this.isNextQuestion = true : this.isNextQuestion = false;
    } else if (this.postData[this.currentNumber - 1].type === 5) {
      //实战作业中的文本+图片题  有一个完成即可
      this.postData[this.currentNumber - 1].selector || this.uploadList.length > 0 ? this.isNextQuestion = true : this.isNextQuestion = false;
    }
  }

  //保存
  saveAnswer(page): void {
    if(!this.clickAble) return
    this.canSave = false;
    this.clickAble = false
    this.isSave = true;
    if(!this.blankSave){
      this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷保存', 'courseUnit': this.lpmapcId, 'type': 0 }).then(() => {
        this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': this.lpmapcId, 'type': 2 }).then();
      });
      let index = this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5);
      if (index !== -1) {
        this.postData[index]['campFileUploadIds'] = this.uploadId;
      }
      // this.formatTableQAData(this.postData);
      let data = {};
      data['campMetaId'] = Number(localStorage.getItem('campId'));
      data['status'] = 10;
      data['openFlag'] = 1;
      if(this.isLastDay && this.campId != 2){
        data['terminalType'] = 2;
        if(this.checkElse){//如果选了其他这个选项在保存前清掉上面个选项已经保存的表单上传的id
          if(this.postData[this.postData.length -1]['campFileUploadIds']){
            this.postData[this.postData.length -1]['campFileUploadIds'] = '';
          }
        }else{//否则选了除其他任意一选项需把最后一题的文本清掉
          this.postData[this.postData.length -1]['selector'] = '';
        }
      }
      data['campExerciseQuestionAnswersVOList'] = this.postData;
      this.exerciseCommitAPI(data, this.exerciseType).then(result => {
      }).catch(err => {
        if (err['error']['code'] === 101) {
          this.saveError = true;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err['error']['msg'];
          setTimeout(() => {
            this.saveError = false;
            this.clickAble = true;
            this.isShowToast = false;
          }, 1500);
        }
      }).then(() => {
        if (!this.saveError) {
          return this.getExerciseDetailAPI(this.lpmapcId).then(result => {
            return this.exerciseGroup = result;
          });
        }
      }).then(() => {
        if (!this.saveError) {
          this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
          this.isShowTip = false;
          this.titleText();
          if(this.page === 'answer'){
            this.isShowToast = true;
            this.toastType = 3;
            setTimeout(() => {
              this.isShowToast = false;
            }, 1500);
          }
          this.clickAble = true;
          console.log("保存")
          if(page == 'list'){
            this.goBack();
          }
          this.openNextQuestion();
          localStorage.removeItem("exerciseGroup");
          localStorage.removeItem("uploadList");
          localStorage.removeItem("pdfList");
          localStorage.removeItem("uploadId")
          localStorage.removeItem("canSave")
          if (this.isLastDay && this.uploadId && !this.checkElse) {
            this.getUploadFileList({
              'constituteId': this.lpmapcId,
              'questionId': this.exerciseGroup['questionGroup'][index]['questionId'],
              'campFileUploadIds': this.uploadId
            }).then(result => {
              this.uploadList = result['newFileList'];
              this.oldUploadList = result['oldFileList'];
              this.uploadDisabled = this.uploadList.length === 10;
              localStorage.setItem("uploadList",JSON.stringify(this.uploadList));
            });
          }
        }
      });
    }

  }

  //提示框继续
  tipsContinue(): void {
    console.log('智能作业临时状态',this.tempWorkStatus);
    console.log('智能作业数据postData',this.postData);
    console.log('智能作业数据this.exerciseGroup',this.exerciseGroup);
    if(this.tempWorkStatus >= 20){
      console.log('该智能作业已提交过',this.exerciseGroup);
      return;
    }
    if(!this.clickAble) return
    this.clickAble = false
    this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '点击作业试卷提交', 'courseUnit': this.lpmapcId, 'type': 0 }).then(() => {
      this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': this.lpmapcId, 'type': 2 }).then();
    });
    if (this.tipType === 'save') {
      this.clickAble = true;
      this.saveAnswer('list');
    } else if (this.tipType === 'finish') {
      // this.formatTableQAData(this.postData);
      let data = {};
      data['campMetaId'] = Number(localStorage.getItem('campId'));
      data['status'] = 20;
      data['openFlag'] = this.openFlag;
      data['campExerciseQuestionAnswersVOList'] = this.postData;
      this.exerciseCommitAPI(data, this.exerciseType).then(result => {
        this.tempWorkStatus = data['status'];
        this.clickAble = true;
        this.isShowTip = false;
        this.isPopupEnter = false;
        this.isShowBackDesc = false;
        this.exerciseGroup.status = 20;
        localStorage.setItem("exerciseGroup",JSON.stringify(this.exerciseGroup));
        this.pageChangedInit('sight', 'finish', 'rgba(246,246,246,1)','linear-gradient(rgb(32, 50, 126), rgb(67, 76, 157))');
        setTimeout(() => {
          this.isShowPopup = false;
          this.commonService.initPage({ 'backgroundColor': 'rgba(246,246,246,1)' });
        }, 100);
      }).catch(err => {
        if (err['error']['code'] === 101) {
          this.saveError = true;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err['error']['msg'];
          setTimeout(() => {
            this.saveError = false;
            this.clickAble = true;
            this.isShowToast = false;
          }, 1500);
        }
      }).then(()=>{
        if(!this.saveError){
          let learningPathMetaId = 0;
          if(Number(localStorage.getItem("campId")) == 1){
            if(this.isLastDay){
              learningPathMetaId = -49601;
            }else if(this.isFirstDay){
              learningPathMetaId = -40401;
            }
          }else if(Number(localStorage.getItem("campId")) == 2){
            if(this.isLastDay){
              learningPathMetaId = -419601;
            }else if(this.isFirstDay){
              learningPathMetaId = 414;
            }
          }else if(Number(localStorage.getItem("campId")) == 3){
            if(this.isLastDay){
              learningPathMetaId = -429601;
            }else if(this.isFirstDay){
              learningPathMetaId = -42401;
            }
          }
          if(this.exerciseGroup.workSource == 'camp' ){
            this.getCampDayProgress(Number(localStorage.getItem("campId")),this.isLastDay || this.isFirstDay? learningPathMetaId : this.learningPathMetaId).then(result=>{
              //确认提交答案的时候需要调用接口
              if (result[0].finished == result[0].total) {
                if(localStorage.getItem("projectId")){
                  this.apiService.getProjectProgress(localStorage.getItem("projectId")).subscribe(res=>{
                    console.log("projectId",res)
                  })
                }else{
                  this.apiService.getSingleProjectProgress().subscribe(res=>{
                    console.log(3333,res)
                  })
                }
              }
            })
          }
        }
      })
    }
  }

  //判断表格题是否可以提交
  judgeTableCanCommit(arr: any): number {
    let a = [];
    arr.forEach(item => {
      console.log(item);
      item['tableData'].forEach(item2 => {
        item2.forEach(item3 => {
          a.push(item3);
        });
      });
    });
    return a.length>0 && a.every(item=>item !== '') && arr.every(item=>item.tableData.length > 0)? a.filter(i => i === '').length : 1;
  }

  slide(direction: string) {
    if (direction == "left") {
      //下一题
      this.currentNumber += 1;
      this.isNextQuestion = false;
      this.slideWrap(2);
      this.openNextQuestion();
      if(this.isLastDay){
        localStorage.setItem("exerciseGroup",JSON.stringify(this.exerciseGroup))
        localStorage.setItem("pdfList",JSON.stringify(this.pdfList))
        this.uploadList = localStorage.getItem("uploadList") && JSON.parse(localStorage.getItem("uploadList")) ? JSON.parse(localStorage.getItem("uploadList")) : [];
      }
    } else {
      //上一题
      if(this.isLastDay && JSON.parse(localStorage.getItem("exerciseGroup"))){
        this.isNextQuestion = true;
        // this.slideWrap(1);
        this.currentNumber -= 1;
      }else{
        this.isNextQuestion = true;
        this.slideWrap(1);
        this.currentNumber -= 1;
      }

    }
    this.titleText();

    setTimeout(()=>{
      if(this.exerciseGroup['questionGroup'][this.currentNumber -1 ].type === 1 || (this.exerciseGroup['questionGroup'][this.currentNumber -1 ].type === 5 && this.checkElse)){
        $('#component-textarea-'+this.exerciseGroup['questionGroup'][this.currentNumber-1].questionId+"-"+this.currentNumber).height($('#component-textarea-'+this.exerciseGroup['questionGroup'][this.currentNumber-1].questionId+"-"+this.currentNumber)[0].scrollHeight)
      }
    })

  }
  //上下题目切换时显示当前题目所答内容
  slideWrap(i){
    if(this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 1){
      //文本题
      this.exerciseGroup['questionGroup'][this.currentNumber -i ].answers = this.postData[this.currentNumber -i ].selector;
    }else if(this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 2){
      //单选题
      const str = String(this.postData[this.currentNumber -i ].selector);
      this.exerciseGroup['questionGroup'][this.currentNumber -i ]['options'].forEach(item=>{
        if(item.optionId == str){
          item.select = true;
        }else{
          item.select = false;
        }
      })
    }else if(this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 3 || this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 6 || this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 8){
      //步骤题
      this.exerciseGroup['questionGroup'][this.currentNumber -i ].tableData = this.postData[this.currentNumber -i ].tableData;
    }else if(this.exerciseGroup['questionGroup'][this.currentNumber -i ].type === 4){
      //多选题
      this.exerciseGroup['questionGroup'][this.currentNumber -i ].answers = this.postData[this.currentNumber -i ].selector;
    }
  }

  //获取用户隐私选项
  getUserOpenFlag(event) {
    this.openFlag = event;
  }


  //完成练习题
  finishExercise(tabNum: number): void {
    let learningPathId = null, courseId = null;
    this.route.queryParams.subscribe(queryParams => {
      learningPathId = queryParams['learningPathId'];
      courseId = queryParams['courseId'];
    });

    if (this.isLastDay) {
      //day7实战作业
      this.router.navigate(['learning-camp-response'], {
        queryParams: {
          tabNum: tabNum,
          constituteId: this.lpmapcId,
          learningPathId,
          courseId,
          isLastDay: this.isLastDay,
          onlyCamp: this.isOnlyCamp
        }
      }).then();
    } else if (this.isFirstDay) {
      this.router.navigate(['learning-camp-response'], {
        queryParams: {
          tabNum: tabNum,
          constituteId: this.lpmapcId,
          learningPathId,
          courseId,
          firstDay: this.isFirstDay,
          onlyCamp: this.isOnlyCamp
        }
      }).then();
    } else {
      if (learningPathId && courseId) {
        this.router.navigate(['learning-camp-response'], {
          queryParams: {
            tabNum: tabNum,
            constituteId: this.lpmapcId,
            learningPathId,
            courseId
          }
        }).then();
      }else {
        if(this.exerciseGroup.workSource == 'homework'){
          if(this.projectId){
            this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId ,projectId : this.projectId} }).then();
          }else if(this.courseLearningPathMetaId){
            this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId ,courseLearningPathMetaId:this.courseLearningPathMetaId} }).then();
          }
        }else{
          this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: tabNum, constituteId: this.lpmapcId } }).then();
        }
      }
    }

  }

  //提交答案
  commitAnswer(status): void {
    let that = this;
    if(status === 1){
      that.postData = that.formatPostData(that.exerciseGroup['questionGroup']);
      console.log('确认提交前的数据',that.postData);
    }
    let tableQAList = that.postData.filter(item => (item['type'] === 3 || item['type'] === 6 || item['type'] === 8)&& item['selector'] !== null);
    if (!this.isLastDay && that.postData.filter(item => item['selector'] === null || item['selector'] === '').length !== 0) {
      that.isShowToast = true;
      that.toastType = 0; 
    }else if(this.isLastDay && this.campId == 2 && that.postData.filter(item=>item.type !== 5 && (item=>item['selector'] === null || item['selector'] === '')).length !== 0 && ((that.postData[that.postData.length-1].selector === null || that.postData[that.postData.length-1].selector === '') && this.uploadId == '')){
      that.isShowToast = true;
      that.toastType = 0;
    }else if(this.isLastDay && this.campId != 2 && ((that.postData.filter(item=>item.type !== 5 && item['selector'] === null).length !== 0 || ((that.postData[that.postData.length-1].selector === null || that.postData[that.postData.length-1].selector === '' ) && this.uploadId === '')) || this.checkElse && that.postData[that.postData.length-1].selector === '' || !this.checkElse && this.uploadId === '')){
      that.isShowToast = true;
      that.toastType = 0;
    }else if (tableQAList.length > 0 && that.judgeTableCanCommit(tableQAList) > 0) {
      that.isShowToast = true;
      that.toastType = 1;
    } else {
      that.tipType = 'finish';
      that.isShowPopup = true;
      setTimeout(() => {
        that.isPopupEnter = true;
      }, 300);

      //提交前先保存一下 防止图片pdf丢失
      if(this.isLastDay && !this.checkElse){
        if(!that.clickAble) return
        that.clickAble = false;
        this.postData[this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5)]['campFileUploadIds'] = this.uploadId;
        let data = {};
        data['campMetaId'] = Number(localStorage.getItem('campId'));
        data['status'] = 10;
        data['openFlag'] = 1;
        data['campExerciseQuestionAnswersVOList'] = this.postData;
        if(this.isLastDay){
          data['terminalType'] = 2;
        }
        this.exerciseCommitAPI(data, this.exerciseType).then((result) => {
          that.clickAble = true;
        });
      }
    }

    setTimeout(() => {
      that.isShowToast = false;
    }, 2000);

    if (that.isWechat && that.isShowPopup) {
      try {
        $('#wx-open-wrap').css('left', '5%');
        let btn = document.getElementById('subscribe-btn');
        btn.addEventListener('success', function (e) {
          $('#wx-open-wrap').css('left', '-200%');
          that.isPopupEnter = false;
          that.isShowPopup = false;
          that.tipsContinue();
        });
        btn.addEventListener('error', function (e) {
          $('#wx-open-wrap').css('left', '-200%');
          that.isPopupEnter = false;
          that.isShowPopup = false;
          that.tipsContinue();
        });
      }
      catch (e) {
        console.log('error', e.message);
        $('#wx-open-wrap').css('left', '-200%');
        that.isPopupEnter = false;
        that.isShowPopup = false;
        that.tipsContinue();
      }
    }
  }

  //是否可以保存（不能保存不出现弹窗提示，可以保存出现弹窗提示）
  getCanSave(event): void {
    this.canSave = event;
    localStorage.setItem("canSave",JSON.stringify(this.canSave));
  }

  //获取子组件提交的练习答案
  getPostData(event): void {
    console.log("event",event);
    this.blankSave = false;
    if(event.wordOverrun){//提示文本框输入已达上限
      this.isShowToast = true;
      this.toastType = 5;
      setTimeout(() => {
        this.isShowToast = false;
      }, 2000);
    }
    //判断是否可以解锁下一题
    if (event.type === 3 || event.type === 6 || event.type === 8) {
      //表格题
      let a = [];
      event['tableData'].forEach(item => {
        item.forEach(item3 => {
          a.push(item3);
        });
      })
      a.some(item => item !== '') || event['tableData'].length >1 ? this.isNextQuestion = true : this.isNextQuestion = false;
    } else if (event.type === 2 || event.type === 4) {
      //选择题
      event.selector ? this.isNextQuestion = true : this.isNextQuestion = false;
      if(event.type === 4 && !this.isLastDay && !this.isFirstDay){//智能作业多选题
        this.isNextQuestion = false;
      }
      if(event.type === 2 && this.isLastDay && this.exerciseGroup['questionGroup'][0].options[this.exerciseGroup['questionGroup'][0].options.length -1].optionId == event['selector']){//实战作业day14是否选择了其他这个选项
        this.checkElse = true;
      }else{
        this.checkElse = false;
      }
    } else if (event.type === 1) {
      //文本题
      event.selector ? this.isNextQuestion = true : this.isNextQuestion = false;
    } else if (event.type === 5) {
      //实战作业中的文本+图片题
      event.selector || this.uploadList.length > 0 ? this.isNextQuestion = true : this.isNextQuestion = false;
    }

    if(JSON.parse(localStorage.getItem("exerciseGroup")) && event.type === 5 && event.selector !== ''){
      this.exerciseGroup['questionGroup'][this.currentNumber-1].answers = event.selector;
      localStorage.setItem("exerciseGroup",JSON.stringify(this.exerciseGroup));
    }

      if (this.postData.length > 0) {
        if (this.postData.filter(item => item.questionId === event.questionId).length !== 0) {
          let index = this.postData.findIndex((v) => v['questionId'] === event['questionId']);
          if (!event['selector']) {
            this.postData[index] = event;
          } else {
            if (index !== -1) {
              this.postData[index] = event;
            }
          }
          if(event.type!=2){//实时更新答题数据传递给子组件
            this.exerciseGroup['questionGroup'][this.currentNumber-1].answers = event.selector;
          }else{
            this.exerciseGroup['questionGroup'][this.currentNumber-1].options.map(item=>{
              if(item.optionId == event.selector){
                item.select = true;
              }
            })
          }
        } else {
          this.postData.push(event);
        }
      } else {
        this.postData.push(event);
      }

      console.log(this.postData,"postData")

      if (this.postData.filter(item => item['type'] === 2 || item['type'] === 4).length > 0 && this.isLastDay) {
        let index = this.postData.findIndex(v => v['type'] === 2 || v['type'] === 4);
        this.getExercisePdfAPI({
          'campMetaId': Number(localStorage.getItem('campId')),
          'optionsIds': this.postData[index]['selector']
        }).then(result => {
          this.pdfList = result;
          console.log(this.pdfList)
        });
      }
  }

  //提示框退出
  closeComponentTip() {
    this.openFlag = 1;
    let index = this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5);
    this.getExerciseDetailAPI(this.lpmapcId).then(result => {
      this.exerciseGroup = result;
      this.isShowTip = false;
    }).then(() => {
      this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
      this.goBack();
      localStorage.removeItem("exerciseGroup");
      localStorage.removeItem("uploadList");
      localStorage.removeItem("pdfList");
      localStorage.removeItem("uploadId");
      localStorage.removeItem("canSave");
      if (this.isLastDay) {
        this.getUploadFileList({
          'constituteId': this.lpmapcId,
          'questionId': this.exerciseGroup['questionGroup'][index]['questionId'],
          'campFileUploadIds': this.uploadId
        }).then(result => {
          this.uploadList = result['newFileList'];
          console.log(this.uploadList)
          this.oldUploadList = result['oldFileList'];
          this.uploadDisabled = this.uploadList.length === 10;
        });
      }
    });
  }

  //页面切换时初始化背景
  pageChangedInit(theme: string, page: string, initColor: string,backgroundImage: string): void {
    this.theme = theme;
    this.page = page;
    this.commonService.initPage({
      'backgroundColor': initColor,
      'backgroundImage' : backgroundImage
    });
  }


  //返回
  exit() {
    this.isShowBackDesc = false;
    let learningPathId = null;
    let courseId = null;
    this.route.queryParams.subscribe(queryParams => {
      learningPathId = queryParams['learningPathId'];
      courseId = queryParams['courseId'];
    });
    if(JSON.parse(localStorage.getItem("canSave"))){
        this.canSave = JSON.parse(localStorage.getItem("canSave"));
    }
    if (this.page === 'list') {
      if (this.tipType !== "finish") {
        this.isShowFinishTip = true;
      } else {
        this.goBack();
      }
    } else if (this.page === 'answer') {
      console.log(this.canSave,"this.canSave")
      if (!this.canSave) {
        this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': this.learningPathMetaId, 'module': '作业', 'btnName': '作业作答', 'courseUnit': this.lpmapcId, 'type': 2 }).then();
        this.getExerciseDetailAPI(this.lpmapcId).then(result => {
          this.exerciseGroup = result;
          this.postData = this.formatPostData(this.exerciseGroup['questionGroup']);
          this.titleText();
          this.goBack();
        });
      } else {
        this.isShowTip = true;
        this.tipType = 'save';
      }
      this.canSave = false;
    }

  }

  goBack() {
    this.isShowFinishTip = false;
    let learningPathId = null;
    let courseId = null;
    this.route.queryParams.subscribe(queryParams => {
      learningPathId = queryParams['learningPathId'];
      courseId = queryParams['courseId'];
    });
    if (this.exerciseType === 3) {
      if (this.isFirstDay) {
        this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { 'firstDay': 1 } });
      } else {
        this.router.navigate(['course-new', learningPathId, courseId], { queryParams: { 'isLastDay': 1 } });
      }
    } else {
      let learningPathId = null;
      let courseId = null;
      this.route.queryParams.subscribe(queryParams => {
        learningPathId = queryParams['learningPathId'];
        courseId = queryParams['courseId'];
      });
      //判断从哪个入口进来
      if (learningPathId && courseId) {
        //从训练营进来
        this.router.navigate(['course-new',learningPathId, courseId]);
      }else {
        if(this.exerciseGroup.workSource == 'homework'){//项目下的智能作业
          let link = [];
          if(this.projectId){
            link = ['learning-project',this.projectId];
          }else if(this.courseLearningPathMetaId){
            link = ['learning-path',this.courseLearningPathMetaId];
          }
          this.router.navigate(link).then();
        }else{
          //从作业簿进来
          this.router.navigate(['exercise-book']).then();
        }
      }
    }
    sessionStorage.removeItem("exerciseScrollTop");
  }

  unFinishExit() {
    if(this.tipType == "showUrl"){
      this.isClick = 1;
      this.downloadPDF(this.downloadUrl);
    }else{
      this.goBack()
    }
  }

  continue() {
    if(this.tipType == "showUrl"){
      if(window.navigator){
        (window.navigator as any).clipboard.writeText( window.location.hostname === 'm.transtalent.cn'? "https://m.transtalent.cn/pc/#/?actualwork=true" :"https://m-uat.transtalent.cn/pc/#/?actualwork=true").then(r=>{
          this.isShowToast = true;
          this.toastType = 4;
          setTimeout(() => {
            this.isShowToast = false;
          }, 1500);
          console.log("复制成功")
          this.isClick = 1;
        })
      }
      this.tipType = "";
      this.isShowFinishTip = false;
    }else{
      this.isShowFinishTip = false;
    }
  }

  /**
   * 关闭私密提交弹出层
   */
  closePopup(): void {
    this.openFlag = 1;
    this.tipType = '';
    $('#wx-open-wrap').css('left', '-200%');
    this.isPopupEnter = false;
    setTimeout(() => {
      this.isShowPopup = false;
    }, 100);
  }


  /**
   * 预览
   * @param event:Object   子组件传递来的预览对象
   */
  showReview(event): void {
    this.previewSource = event;
    this.isShowPreview = true;
  }

  /**
   * 关闭预览
   */
  closePreview(): void {
    this.isShowPreview = false;
  }

  /**
   * 接受子组件传递过来的需要删除文件的下标并删除该文件
   * @param event: Object   子组件传递来的数据
   */
  deleteUploadFile(event): void {
    this.uploadList = this.uploadList.filter((item, i) => i !== event['index']);
    this.uploadDisabled = this.uploadList.length === 10;
    let campFileUploadIds = '';
    this.uploadList.forEach((item, i) => {
      campFileUploadIds = i !== this.uploadList.length - 1 ? campFileUploadIds + item['id'] + '|' : campFileUploadIds + item['id'];
    });
    this.postData[this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5)]['campFileUploadIds'] = campFileUploadIds;
    // this.formatTableQAData(this.postData);
    let data = {};
    data['campMetaId'] = Number(localStorage.getItem('campId'));
    data['status'] = 10;
    data['openFlag'] = 1;
    data['campExerciseQuestionAnswersVOList'] = this.postData;
    console.log(this.uploadList)
    if(this.isLastDay && this.uploadList.length == 0){
      data['terminalType'] = 2;
      this.terminalType = 2;
    }
    this.exerciseCommitAPI(data, this.exerciseType).then(() => {
      this.uploadId = campFileUploadIds;
    });
    localStorage.setItem("uploadList",JSON.stringify(this.uploadList));
    localStorage.setItem("uploadId",this.uploadId)
  }


  /**
   * 文件上传
   * @param files: files 上传的文件
   */
  fileUpload(files): void {
    if (navigator.onLine) {
      this.fileUploadAPI({ 'files': files['files'], 'id': files['id'] }).then(result => {
        this.uploadId = this.uploadId === '' ? String(result['id']) : this.uploadId + '|' + result['id'];
        $(files.el).attr('type', 'file');
      }).then(() => {
        return this.getUploadFileList({
          'constituteId': this.lpmapcId,
          'questionId': files['id'],
          'campFileUploadIds': this.uploadId
        }).then(result => {
          return this.uploadList = result['newFileList'];
        });
      }).then(()=>{
        this.postData[this.commonService.getIndexByConditionIdInLists(this.postData, 'type', 5)]['campFileUploadIds'] = this.uploadId;
        let data = {};
        data['campMetaId'] = Number(localStorage.getItem('campId'));
        data['status'] = 10;
        data['openFlag'] = 1;
        data['campExerciseQuestionAnswersVOList'] = this.postData;
        if(this.isLastDay){
          data['terminalType'] = 2;
        }
        this.exerciseCommitAPI(data, this.exerciseType).then(() => {
          this.uploadId = this.uploadId;
        });
      }).then(() => {
        this.oldUploadList = this.oldUploadList ? this.oldUploadList : [];
        // let result = this.uploadList.length === this.oldUploadList.length && this.uploadList.every(a => this.oldUploadList.some(b => a === b)) && this.oldUploadList.every(_b => this.uploadList.some(_a => _a === _b));
        // console.log(result);
        this.uploadDisabled = this.uploadList.length === 10;
        localStorage.setItem("uploadList",JSON.stringify(this.uploadList));
        localStorage.setItem("uploadId",this.uploadId)
      });
    } else {
      this.isShowToast = true;
      this.toastType = 2;
      this.errTxt = '保存失败，请检查你的网络设置';
      setTimeout(() => {
        this.isShowToast = false;
        $('#upload_input').attr('type', 'file');
      }, 2000);
    }

  }

  /**
   * 下载PDF文件
   * @param url: Number PDF's URL
   */
  downloadPDF(url: string): void {
    //先判断是否已经点过
    this.downloadUrl = url;
      if(!this.isClick && this.campId != 2){
        //没有点过才保存
        this.tipType = "showUrl";
        this.isShowFinishTip = true;
        this.commonService.setOnceIno(this.onceValue).subscribe();
      }else{
        this.tipType = "";
        this.isShowFinishTip = false;
        window.open(this.downloadUrl);
      }

    // window.open('ddilearner/v2/camp/applicationPractice/actualOperation/downloadFile/' + id)
  }


  /**
   * 根据试卷ID获取当前试卷所有小题题目
   * @param lpmapcId: Number  试卷Id
   */
  getExerciseDetailAPI(lpmapcId: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/applicationPractice/getQuestionGroup/' + lpmapcId,
    }).toPromise();
  }


  /**
   * 提交答案
   * @param postData: JSONObject 作答数据
   * @param exerciseType: Number 作业类型
   */
  exerciseCommitAPI(postData: any, exerciseType: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': exerciseType === 3 && !this.isLastDay ? 'ddilearner/v2/camp/applicationPractice/actualOperation/saveFirstDayTask' : 'ddilearner/v2/camp/applicationPractice/saveAnswers'
    }).toPromise();
  }


  /**
   * 根据第一题选择的选项id获取PDF文件
   * @param postData: JSONObject 选择题选项
   */
  getExercisePdfAPI(postData: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getExercisePdf',
    }).toPromise();
  }

  /**
   * 获取上传文件列表
   * @param postData: JSONObject 查询文件条件对象
   */
  getUploadFileList(postData: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'data': postData,
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/getCampFileList',
    }).toPromise();
  }

  /**
   * 文件上传
   * @param data: Object 上传文件需要的参数
   */
  fileUploadAPI(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: 'ddilearner/v2/camp/applicationPractice/actualOperation/' + this.lpmapcId + '/' + data['id'] + '/fileUpload',
        type: 'POST',
        cache: false,
        data: data['files'],
        processData: false,
        contentType: false,
        headers : {
          'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
          'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
        },
        beforeSend: XMLHttpRequest => {
          this.isShowLoading = true;
        },
        success: res => {
          resolve(res);
          setTimeout(() => {
            this.isShowLoading = false;
            $('#upload_input').attr('type', 'file');
          }, 500);
        },
        error: err => {
          if(err.status === 401 && Number(err.responseJSON.code) === 106){
            this.storeService.notification.notAuthed.next(true);
          }
          this.isShowLoading = false;
          this.isShowToast = true;
          this.toastType = 2;
          this.errTxt = err.status === 413 ? '保存失败，请上传小于10M文件！' : err['responseJSON']['msg'];
          setTimeout(() => {
            this.isShowToast = false;
            $('#upload_input').attr('type', 'file');
          }, 2000);

        }
      });
    });
  }

  getNextBtn(event){
    this.isNextQuestion = event;
  }

  elementScroll(event){
    const scrollTop = event.target.scrollTop;
    sessionStorage.setItem("exerciseScrollTop",scrollTop)
  }


  /**
   * 删除上传文件
   * @param data: Object 删除文件需要的参数
   */
  deleteUploadFileAPI(data: any): Promise<any> {
    return this.apiService.ajax({
      'type': 'POST',
      'url': 'ddilearner/v2/camp/applicationPractice/actualOperation/deleteCampUploadFile',
      'data': data
    }).toPromise();
  }

  //获取训练营课程进度(新接口)
  getCampDayProgress(campId: number, learningPathMetaId: number): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/dayProgress?campMetaId=' + campId + '&learningPathMetaId=' + learningPathMetaId
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work.component.ts